import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { Box } from "@mui-wrapper";
import { NO_TRANSLATE_CLASS, Skeleton } from "@flat-ui";
import { useLazyImage } from "@hooks/use-lazy-image";
import { useEffect, useState } from "react";

/** Height for the card thumbnail image */
export const IMAGE_HEIGHT = "168px";
/**
 * Component that shows the image of a card, fitted to the size of the card's media.
 */
export function FaroCardImage(t0) {
  const $ = _c(25);
  const {
    src,
    fallbackSrc,
    contextType,
    contextId,
    alt: t1,
    shouldNotTranslate: t2
  } = t0;
  const alt = t1 === undefined ? "" : t1;
  const shouldNotTranslate = t2 === undefined ? false : t2;
  const [isLoaded, setIsLoaded] = useState(false);
  const [failedSrc, setFailedSrc] = useState(null);
  const companyId = useCompanyId();
  const companyIdCacheKey = `${companyId}`;
  const {
    imageUrl,
    hasError
  } = useLazyImage(src, companyIdCacheKey, contextType, contextId);
  const shouldUseFallback = hasError || src === failedSrc;
  let t3;
  let t4;
  if ($[0] !== hasError || $[1] !== imageUrl) {
    t3 = () => {
      if (imageUrl !== null || hasError) {
        setIsLoaded(true);
      }
    };
    t4 = [imageUrl, hasError];
    $[0] = hasError;
    $[1] = imageUrl;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      position: "relative"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = isLoaded ? "none" : "block";
  let t7;
  if ($[5] !== t6) {
    t7 = <Skeleton variant="rectangular" height={IMAGE_HEIGHT} width="100%" sx={{
      position: "absolute",
      display: t6
    }} />;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = shouldNotTranslate ? NO_TRANSLATE_CLASS : undefined;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      alignContent: "center",
      height: IMAGE_HEIGHT,
      width: "100%"
    };
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const t10 = shouldUseFallback ? fallbackSrc : imageUrl ?? undefined;
  let t11;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setIsLoaded(true);
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  let t12;
  if ($[9] !== shouldUseFallback || $[10] !== src) {
    t12 = () => !shouldUseFallback && setFailedSrc(src);
    $[9] = shouldUseFallback;
    $[10] = src;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const t13 = isLoaded ? "block" : "none";
  let t14;
  if ($[12] !== t13) {
    t14 = {
      maxHeight: "100%",
      maxWidth: "100%",
      display: t13,
      justifySelf: "center"
    };
    $[12] = t13;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== alt || $[15] !== t10 || $[16] !== t12 || $[17] !== t14) {
    t15 = <Box component="img" src={t10} alt={alt} loading="lazy" onLoad={t11} onError={t12} sx={t14} />;
    $[14] = alt;
    $[15] = t10;
    $[16] = t12;
    $[17] = t14;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== t15 || $[20] !== t8) {
    t16 = <Box className={t8} sx={t9}>{t15}</Box>;
    $[19] = t15;
    $[20] = t8;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t16 || $[23] !== t7) {
    t17 = <Box component="div" sx={t5}>{t7}{t16}</Box>;
    $[22] = t16;
    $[23] = t7;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  return t17;
}